
import React, { PureComponent } from 'react'
import { push } from 'connected-react-router'
import { reduxForm } from 'redux-form'
import { connect } from 'react-redux'
import SuperAdminActions from 'store/redux/superadmin'
import GlobalActions from 'store/redux/global'
import { Table, Form } from 'reactstrap'
import { FG, Button, Modal } from 'components'
import { pageData } from 'decorators'
import { translate } from 'react-i18next'
import AdminTemplate from '../../templates/AdminTemplate'
import './SuperAdminHome.css'

@connect(
    state => ({
        mcList: state.superadmin.mcList,
        isLoading: state.global.loading,
        isAuthenticated: state.auth.isAuthenticated,
        reconnecting: state.auth.reconnecting,
    }),
    {
        clean: SuperAdminActions.clean,
        requestMcList: SuperAdminActions.requestMcList,
        requestNewMc: SuperAdminActions.requestNewMc,
        requestUpdateMc: SuperAdminActions.requestUpdateMc,
        requestUpdateMcPassword: SuperAdminActions.requestUpdateMcPassword,
        requestDeleteMc: SuperAdminActions.requestDeleteMc,
        modalRequest: GlobalActions.request,
        navigate: push
    }
)
@pageData({ title: 'SuperAdmin Home' })
@translate()
@reduxForm({ form: 'superadminHome' })
export class SuperAdminHome extends PureComponent {
    state = {
        isModalOpen: false
    }
    componentWillMount() {
        const { isAuthenticated, reconnecting, clean } = this.props
        clean()
        if (isAuthenticated && !reconnecting) {
            this.fetchMcList()
        }
        this.modalAction = 'new'
        this.selectedUuid = null
        this.selectedUsername = null
    }
    componentWillReceiveProps(nextProps) {
        if (this.props.reconnecting && !nextProps.reconnecting) {
            this.fetchMcList()
        }
        if (this.props.isLoading && !nextProps.isLoading) {
            this.modalDismiss()
        }
    }

    onSubmit = ({ username, password }) => {
        const { requestNewMc, requestUpdateMc, requestUpdateMcPassword } = this.props
        if (this.modalAction === 'edit') {
            requestUpdateMc({ uuid: this.selectedUuid, username })
        } else if (this.modalAction === 'editPwd') {
            requestUpdateMcPassword({ uuid: this.selectedUuid, password })
        } else {
            requestNewMc({ username, password })
        }
    }

    showModal = (action, { uuid = null, username = null } = {}) => {
        const { change, reset } = this.props
        this.modalAction = action
        this.selectedUuid = uuid
        this.selectedUsername = username
        reset()
        if (action === 'edit') {
            change('username', username)
        } else {
            change('username', '')
        }
        this.setState({ isModalOpen: true })
    }
    modalDismiss = () => {
        this.modalAction = null
        this.selectedUuid = null
        this.selectedUsername = null
        this.setState({ isModalOpen: false })
    }

    fetchMcList = () => {
        const { requestMcList } = this.props
        requestMcList()
    }

    tryDeleteMc = ({ uuid, username }) => {
        const { modalRequest, requestDeleteMc, t } = this.props
        modalRequest({
            title: t('superadmin.home.mcList.deleteModal.title'),
            text: t('superadmin.home.mcList.deleteModal.text', { username }),
            actionBtns: [
                { text: t('superadmin.home.mcList.deleteModal.doneBtn'), action: () => requestDeleteMc(uuid) },
                { text: t('superadmin.home.mcList.deleteModal.cancelBtn') }
            ]
        })
    }

    renderMc = ({ uuid, username }, index) => {
        const { t } = this.props
        return (
            <tr key={index}>
                <td className="mc">
                    {username}
                </td>
                <td className="mc-actions">
                    <a onClick={() => this.showModal('edit', { uuid, username })}>{t('superadmin.home.mcList.edit')}</a>
                    <a onClick={() => this.showModal('editPwd', { uuid, username })}>{t('superadmin.home.mcList.editPwd')}</a>
                    <a onClick={() => this.tryDeleteMc({ uuid, username })}>{t('superadmin.home.mcList.delete')}</a>
                </td>
            </tr>
        )
    }
    render() {
        const { mcList = [], isLoading, handleSubmit, navigate, t } = this.props
        const { isModalOpen } = this.state
        const modalTitle = this.modalAction ? t(`superadmin.home.mcModal.title.${this.modalAction}`, { username: this.selectedUsername }) : null
        return (
            <AdminTemplate className="SuperAdminHome px-5 pb-5">
                <h1>{t('superadmin.home.title')}</h1>
                <Button tag="a" color="primary" size="sm" className="config-file flex-self-right" onClick={() => navigate('/admin/config')}>
                    {t('superadmin.home.configFile')}
                </Button>

                <h2>{t('superadmin.home.mcList.title')}</h2>
                <Table>
                    <tbody>
                        {mcList.map(this.renderMc)}
                        <tr>
                            <td colSpan="10">
                                <a className="new-mc" onClick={() => this.showModal('new')}>{t('superadmin.home.mcList.newBtn')}</a>
                            </td>
                        </tr>
                    </tbody>
                </Table>

                <Modal className="SuperAdminHome-Modal" isOpen={isModalOpen} title={modalTitle} onDismiss={this.modalDismiss}>
                    <Form className={{ Submitting: isLoading }} onSubmit={handleSubmit(this.onSubmit)}>
                        <div className={this.modalAction !== 'new' ? 'flex row-center-top' : 'flex row-stretch-top'}>
                            {this.modalAction !== 'editPwd' && <FG.Text id="username" name="username" label={t('superadmin.home.mcModal.username')} required />}
                            {this.modalAction !== 'edit' && <FG.Text id="password" name="password" label={t('superadmin.home.mcModal.password')} className="ml-3" required />}
                        </div>
                    </Form>
                    <div className="modal-actions flex row-stretch">
                        <Button outline onClick={this.modalDismiss}>
                            {t('superadmin.home.mcModal.cancelBtn')}
                        </Button>
                        <Button color="primary" loading={isLoading} onClick={handleSubmit(this.onSubmit)}>
                            {t('superadmin.home.mcModal.saveBtn')}
                        </Button>
                    </div>
                </Modal>
            </AdminTemplate>
        )
    }
}



// WEBPACK FOOTER //
// src/pages/SuperAdmin/Home/SuperAdminHome.js